export class Tags {

	constructor() {
		this.portfolio = document.querySelector('.portfolio__table > ul.portfolio__table-list')
	}

    select() {
        let params = $('form.portfolio-page__tags').serialize()
        if(params.length != 0){
			$('.portfolio__table > ul.portfolio__table-list').fadeOut()
			let _this = this
			setTimeout(function () { _this.portfolio.innerHTML = '' }, 500);
			params = this.get(params)
			params = this.set(params)
			setTimeout(function () { _this.load(params) }, 500);
		}
    }

	get(str) {
		let obj = {}
		new URLSearchParams(str).forEach(function(val,key) {
			if (obj[key] !== undefined) { 
				if (!Array.isArray(obj[key])) {
					obj[key] = [obj[key]]
				}
				obj[key].push(val)
			} else {
				obj[key] = val
			}
		})
		return obj
	}

	set(obj) {
        let str = ''
        for (let el in obj) {
            str += el.substr(el.indexOf('_')+1) + ','
        }
        str = str.substring(0, str.length - 1);
		return str
	}

	load(params)
	{
        let _this = this
		$.ajax({
			url: "/ajax.php?mid=2",
			type: 'POST',
			data: 'params='+params+'&action=select_projects',
			dataType: "json",
			success: function(res)
			{
                
				if(res.result) 
				{
					for(let item in res.result) {

						let li = document.createElement('li')
						li.classList.add('portfolio__table-item')
						li.classList.add('portfolio-card')

						let a = document.createElement('a')
						a.classList.add('portfolio-card__link')
						a.href = res.result[item][0]
						li.append(a)

						let container = document.createElement('div')
						container.classList.add('portfolio-card__container')

						let services = document.createElement('div')
						services.classList.add('portfolio-card__services')

						let ul = document.createElement('ul')
						ul.classList.add('portfolio-card__services-list')
						ul.classList.add('dragscroll')
						let tags = res.result[item][8]
						for(let tag in tags) {
							let i = document.createElement('li')
							i.classList.add('portfolio-card__services-item')
							let alink = document.createElement('a')
							alink.classList.add('portfolio-card__services-link')
							alink.href = '/services/' + tags[tag][0] + '/'
							alink.append(tags[tag][1])
							i.append(alink)
							ul.append(i)
						}
						services.append(ul)
						container.append(services)

						let wrapper = document.createElement('div')
						wrapper.classList.add('portfolio-card__image-wrapper')

						let img = document.createElement('img')
						img.classList.add('portfolio-card__image')
						img.src = res.result[item][2]
						img.alt = res.result[item][5]
						img.width = 225
						img.height = 225
						wrapper.append(img)
						container.append(wrapper)

						let bottom = document.createElement('div')
						bottom.classList.add('portfolio-card__bottom')

						let title = document.createElement('div')
						title.classList.add('portfolio-card__title')
						title.append(res.result[item][1])
						bottom.append(title)

						let more = document.createElement('div')
						more.classList.add('portfolio-card__more')

						let btn = document.createElement('a')
						btn.classList.add('portfolio-card__more-btn')
						btn.title = res.result[item][5]
						btn.rel = 'nofollow'
						btn.href = res.result[item][4]

						let span = document.createElement('span')
						span.append('Смотреть ')
						btn.append(span)

						btn.innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M18.6271 8.69543C17.9962 8.07882 17.9962 7.07907 18.6271 6.46246C19.2579 5.84585 20.2806 5.84585 20.9115 6.46246L29.5269 14.8836C30.1577 15.5002 30.1577 16.4998 29.5269 17.1164L20.9115 25.5375C20.2806 26.1542 19.2579 26.1542 18.6271 25.5375C17.9962 24.9209 17.9962 23.9213 18.6271 23.3047L24.4847 17.579H3.61539C2.72324 17.579 2 16.872 2 16C2 15.128 2.72324 14.4211 3.61539 14.4211H24.4847L18.6271 8.69543Z" fill="black"></path></svg>'

						more.append(btn)
						bottom.append(more)
						container.append(bottom)
						li.append(container)
						_this.portfolio.append(li)
						$('.portfolio__table > ul.portfolio__table-list').fadeIn()
					}
				}
				else
				{
					alert(res.empty)
				}

			},
			error: function(error)
			{
				alert('Ошибка отправки данных!')
			}			
		})
	}

}